<template>
    <div>
        <div class="slide-title">
            <h2>{{slide.type}}</h2> 
            <hr>
            <div v-if="!slide.type.includes('Education')">
                <md-field style="width: 260px; margin: auto; text-align: center;">
                    <label style="width: 100%">
                        Timepoint
                    </label>
                    <md-input 
                        v-model="slide.timepoint" 
                        style="font-size: 125%; text-align: center"
                        @blur="saveSlide()"
                    ></md-input>
                </md-field>
            </div>
            <div v-else>
                <md-field style="width: 260px; margin: auto; text-align: center;">
                    <label style="width: 100%">
                        Title
                    </label>
                    <md-input
                        v-model="slide.slide.title" 
                        style="font-size: 125%; text-align: center;"
                        @blur="saveSlide()"
                    ></md-input>
                </md-field>
            </div>
            <hr>
        </div>
        <quill-editor 
            ref="quillInfoEditor" 
            @blur="saveSlide()"
            v-model="slide.slide.corpus"
            :options="{'placeholder': 'Write description here...'}"
        ></quill-editor>
        <CitationManager :citations="slide.slide.citations" @save="saveSlide(false)" v-if="slide.type.includes('Education')"/>
        <ResourceGallery :resourceList="slide.slide.resources" v-on:saveSlide="saveSlide(false)"></ResourceGallery>
        <hr>
        <md-button class="md-raised md-primary" @click="saveSlide(true)" style="background-color: green">
            Save
        </md-button>
        <md-button class="md-raised md-accent md-icon-button slide-delete-btn" @click="deleteSlide()">
            <md-icon>delete_forever</md-icon>
        </md-button>
    </div>
</template>

<script>

// require styles
import ResourceGallery from './Gallery.vue'
import CitationManager from './CitationManager.vue'

export default {
    props: {
        slide: {
            type: Object
        },
    },
    data: function(){
        return {
        }
    },
    components: {
        ResourceGallery,
        CitationManager,
    },
    methods: {
        saveSlide: function(closeSlide) {
            this.$emit('saveSlide', [this.slide, closeSlide])
        },
        deleteSlide: function(){
            this.$emit('deleteSlide', this.slide)
        },
        clearQuillHistory() {
            this.$refs.quillInfoEditor.quill.history.clear();
        }
    },
    mounted() {
        this.$nextTick(function(){
            this.clearQuillHistory();
        })
    },
    watch: {
        "slide.id"() {
            setTimeout(() => {
                this.clearQuillHistory();
            }, 500)
        }
    }
}
</script>

<style>
    /* Remove certain controls from quill editor */
    .ql-image, .ql-video, .ql-blockquote, .ql-code-block, .ql-header, .ql-direction{
        display: none !important;
    }
</style>